import { render } from "./EditCustomerView.vue?vue&type=template&id=5d9e9da8"
import script from "./EditCustomerView.vue?vue&type=script&lang=js"
export * from "./EditCustomerView.vue?vue&type=script&lang=js"

import exportComponent from "/Users/kokleng/Documents/old_macbook/document/Dollar/core_system/from_gitlab/pos-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__